import { bizGet, bizPost } from '@/shared/api/bizClient';
import type {
  BusinessProfileRecord,
  DeployFormValues,
  DeploymentRecord,
} from './types';

interface ListResponse<T> {
  items: T[];
}

function toTenantIds(values: DeployFormValues): string[] | null {
  if (values.tenantScope !== 'tenant_list' || !values.tenantIds) return null;
  const ids = values.tenantIds
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);
  return ids.length > 0 ? ids : null;
}

export async function listProfiles(): Promise<BusinessProfileRecord[]> {
  const response = await bizGet<ListResponse<BusinessProfileRecord>>('/biz/admin/profiles');
  return response.items;
}

export async function getProfile(
  subVerticalKey: string,
): Promise<BusinessProfileRecord | null> {
  return bizGet<BusinessProfileRecord>(
    `/biz/admin/profiles/${encodeURIComponent(subVerticalKey)}`,
  );
}

export async function listDeployments(
  subVerticalKey: string,
): Promise<DeploymentRecord[]> {
  const response = await bizGet<ListResponse<DeploymentRecord>>(
    `/biz/admin/profiles/${encodeURIComponent(subVerticalKey)}/deployments`,
  );
  return response.items;
}

export async function deployProfile(
  subVerticalKey: string,
  values: DeployFormValues,
  _actor: { id: string; name: string },
): Promise<DeploymentRecord> {
  return bizPost<DeploymentRecord, {
    mode: DeployFormValues['mode'];
    tenantScope: DeployFormValues['tenantScope'];
    percentage?: number;
    tenantIds?: string[] | null;
    reason: string;
  }>(
    `/biz/admin/profiles/${encodeURIComponent(subVerticalKey)}/deploy`,
    {
      mode: values.mode,
      tenantScope: values.tenantScope,
      ...(values.percentage !== undefined ? { percentage: values.percentage } : {}),
      tenantIds: toTenantIds(values),
      reason: values.reason,
    },
  );
}
